import React from 'react';
import { Text } from './typography.styles';
import { TypographyProps } from './types';
import { typographySizes } from './tokens';

export const Typography: React.FC<TypographyProps> = ({
    size = 'body2_long',
    color = 'neutral_90',
    align = 'start',
    children,
    ...props
}) => {
    const font = typographySizes[size] || typographySizes.body1_long;
    return (
        <Text $font={font} $color={color} $align={align} as={font.tag} {...props}>
            {children}
        </Text>
    );
};
